// extracted by mini-css-extract-plugin
export var activityContainer = "_m7-0";
export var typingIndicatorContainer = "_m7-1";
export var typingIndicatorDot = "_m7-2";
export var wave = "_m7-3";